export default "__VITE_ASSET__BpajOHwg__"